import { AuthPublicGuard, AuthProviderPrivateGuard, AuthPrivateGuard } from './auth.guard'
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { Routes, RouterModule } from '@angular/router'

const routes: Routes = [{
		path: 'login',
		canLoad: [AuthPublicGuard],
		loadChildren: './modules/login/login.module#LoginModule',
	}, {
		path: 'register',
		canLoad: [AuthPublicGuard],
		loadChildren: './modules/register/register.module#RegisterModule',
	}, {
		path: 'p',
		canLoad: [AuthProviderPrivateGuard],
		loadChildren: './modules/private-provider/private.provider.module#PrivateProviderModule',
	}, {
		path: '',
		canLoad: [AuthPrivateGuard],
		loadChildren: './modules/private/private.module#PrivateModule',
	}
]

@NgModule({
	imports: [CommonModule, RouterModule.forRoot(routes, { useHash: false })],
	exports: [RouterModule],
	providers: []
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// D:/jordan/stunii-cms-stunii-cms-Appzorro1/stunii-cms-stunii-cms-Appzorro1/src/app/auth.routes.ts